import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AdminBreadCrumb from '../components/content-panes/admin-breadcrumbs/adminBreadCrumb';
import SideBarNav from '../components/content-panes/side-bar/sideBarNavigation';
import { Col, Container, Row } from 'react-bootstrap';
import AdminHeader from '../components/content-panes/admin-header/adminHeader';
import { UserProfile } from '../components/content-panes/admin-pages/user-profile/userProfile';
import CandidateListing from '../components/content-panes/admin-candidate/candidateListing';
import { UserManagement } from '../components/content-panes/admin-pages/user-management/userManagement';
import CandidateAssignment from '../components/content-panes/admin-pages/admin-candidate-assign/candidateAssignment';
import AddClient from '../components/content-panes/admin-pages/add-client/addClient';
import ClientListing from '../components/content-panes/admin-pages/client-listing/clientListing';
import CandidatePersonalInfoForm from '../components/content-panes/admin-candidate/candidate-forms/personal-details/candiatePersonalDetails';
import CandidateDataForm from '../components/content-panes/admin-candidate/candidateDataForm';
import { BulkFileUploadContainer } from '../components/content-panes/admin-candidate/bulk-fileupload/fileUploadContainer';
import UnapprovedCandidates from '../components/content-panes/admin-candidate/unapproved-candidate/unapprovedCandidate';
import AssignedCandidates from '../components/content-panes/admin-pages/admin-candidate-assign/assignedCandidates';
import MasterDataAdd from '../components/content-panes/admin-pages/master-data-add/masterDataAdd';
import SelfRegisteredCandidates from '../components/content-panes/admin-candidate/self-registered/selfRegisteredCandidates';
import { QueryClient } from '@tanstack/react-query';
import { QueryClientProvider } from '@tanstack/react-query';
import { decodeJWT } from '../services/candidateService';
import { ProfileImageProvider } from '../components/content-panes/admin-pages/user-profile/profileImageContext';
import { useProfileImage } from '../components/content-panes/admin-pages/user-profile/profileImageContext';
import Loader from '../components/content-panes/admin-candidate/loader/Loader';
import CandidateCuratedClients from '../components/content-panes/admin-candidate/candiate-info-nav/candidateCuratedClients';
import AdminAutomatedInterviews from '../components/content-panes/admin-pages/automated-interviews/adminAutomatedInterviews';
import JobNotificationBatches from '../components/content-panes/admin-pages/job-Notification-Batch/jobNotificationBatches';
import CareerGuidanceListing from '../components/content-panes/admin-pages/career-guidance/careerGuidanceListing';

export const AdminContainer = () => {
  const queryClient = new QueryClient();
  const decoded = decodeJWT(window.localStorage.getItem('authToken'));

  return (
    <ProfileImageProvider>
      <InnerAdminContainer queryClient={queryClient} decoded={decoded} />
    </ProfileImageProvider>
  );
};

const InnerAdminContainer = ({ queryClient, decoded }) => {
  const { loading } = useProfileImage();

  return (
    <>
      {loading && <Loader />}
      <AdminHeader />
      <Container fluid>
        <BrowserRouter>
          <Row>
            <Col className="sideBar" xxl={2} xl={2} md lg={2}>
              <SideBarNav />
            </Col>
            <Col className="contentPane" xxl={10} xl={10} md={10} lg={10}>
              <AdminBreadCrumb />
              <QueryClientProvider client={queryClient}>
                <Routes>
                  <Route path="user-profile" element={<UserProfile />} />
                  <Route path="/candidates" element={<CandidateListing />} />
                  <Route
                    path="/users"
                    element={
                      <UserManagement currentUserRole={decoded.roles} />
                    }
                  />
                  <Route path="/candidate-assignment" element={<CandidateAssignment />} />
                  <Route path="/assigned-candidates" element={<AssignedCandidates />} />
                  <Route path="/bulk-resume-upload" element={<BulkFileUploadContainer />} />
                  <Route path="/add-client" element={<AddClient />} />
                  <Route path="/update-client" element={<AddClient />} />
                  <Route path="/clients" element={<ClientListing />} />
                  <Route path="/unapproved-candidates" element={<UnapprovedCandidates />} />
                  <Route path="/job-notification-batches" element={<JobNotificationBatches />} />
                  <Route
                    path="/career-guidance"
                    element={<CareerGuidanceListing />}
                  />
                  <Route path="/self-registered-candidates" element={<SelfRegisteredCandidates />} />
                  <Route path="/assigned-candidates" element={<AssignedCandidates />} />
                  <Route path="/master-data" element={<MasterDataAdd />} />
                  <Route path="/ai-interviews" element={<AdminAutomatedInterviews />} />
                  <Route path="/candidate/*" element={<CandidateDataForm />}>
                    <Route path="candidate-personal-info/:candidateId" element={<CandidatePersonalInfoForm />} />
                    <Route exact path="candidate-personal-info" element={<CandidatePersonalInfoForm />} />
                    <Route path="candidate-work-experience" element={<CandidatePersonalInfoForm />} />
                    <Route path="candidate-education-details" element={<CandidatePersonalInfoForm />} />
                    <Route path="candidate-compensation-details" element={<CandidatePersonalInfoForm />} />
                    <Route path="candidate-value-adds" element={<CandidatePersonalInfoForm />} />
                    <Route path="candidate-curated-clients" element={<CandidateCuratedClients />} />
                  </Route>
                </Routes>
              </QueryClientProvider>
            </Col>
          </Row>
        </BrowserRouter>
      </Container>
    </>
  );
};
